import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, Paper } from '@mui/material';
import ListadoConceptos from './components/ListadoConceptos';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allConceptosAction,
  setActivoConceptosAction,
} from './ConceptosAction';
import FormConceptos from './components/FormConceptos';

const ConceptosView = () => {
  const dispatch = Redux.useDispatch();

  const conceptosStore = Redux.useSelector((state) => state.conceptos);
  const [isDelete, setIsDelete] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoConceptosAction(dispatch, null);
            await allConceptosAction(dispatch, conceptosStore.params);
          }}
          disabled={
            conceptosStore.loadingAll || conceptosStore.all.length === 0
          }
          white
          refreshIcon
          text={conceptosStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={4}>
        <Paper elevation={5} sx={{ pb: 1 }}>
          <FormConceptos isDelete={isDelete} />
        </Paper>
      </Grid>
      <Grid item md={8}>
        <ListadoConceptos
          isDelete={isDelete}
          setIsDelete={(v) => setIsDelete(v)}
        />
      </Grid>
    </Grid>
  );
};

export default ConceptosView;
